import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import EssentialLayout from "@/components/menu-management/manage-essential/essential-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import AddOnsTabs from "@/components/menu-management/manage-essential/essential-drinks/addons/addons-tabs";
import { useParams } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { useFetchAllMenuData } from "@/hooks/use-fetch-all-menu-data";
import { useMemo, useState } from "react";
import EssentialSkeleton from "@/components/skeleton/essential-skeleton";

function EssentialSpecialMenu() {
  const { id } = useParams();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("add-ons");

  const fetchOnly = useMemo(() => {
    switch (activeTab) {
      case "add-ons":
        return ["addOns"];
      default:
        return ["addOns"];
    }
  }, [activeTab]);

  const { groupLoading } = useFetchAllMenuData(user?.restaurant_id, id, {
    fetchOnly,
  });

  if (groupLoading) return <EssentialSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <EssentialLayout
        pageName={{ title: "Drinks List" }}
        paths={[
          { name: "home", path: "/home" },
          { name: "Back Office", path: "/backoffice/overview" },
          { name: "Menu Management", path: "/backoffice/menu/drinks" },
          { name: "Drinks", path: "/backoffice/menu/drinks" },
        ]}
      >
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs
            valueKey="essential-special-menu"
            className="bg-transparent relative"
            defaultValue="add-ons"
            onValueChange={setActiveTab}
          >
            <TabsList className="grid grid-cols-1 w-[150px]">
              <Separator className="absolute top-8" />
              <TabsTrigger value="add-ons">Add-ons</TabsTrigger>
            </TabsList>
            <AddOnsTabs />
          </Tabs>
        </Card>
      </EssentialLayout>
    </Layout2>
  );
}

export default EssentialSpecialMenu;
